module.exports = __webpack_public_path__ + "img/icon-select-hover.3fc92e01.svg";